<app-modal-card>
  <p class="text-[68px] leading-none" aria-hidden="true">⚠️</p>

  <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">{{ title() }}</p>

  @if (message()) {
  <p class="text-[14px] fg-gris-1 text-center mt-[12px]">{{ message() }}</p>
  }

  <p class="text-[14px] fg-gris-1 text-center mt-[12px]">
    {{ currentOrdersLabel() }}
    <span class="font-semibold fg-noir-2">{{ currentOrdersCount() }}</span>
  </p>
  <p class="text-[14px] fg-gris-1 text-center">
    {{ maxOrdersLabel() }}
    <span class="font-semibold fg-noir-2">{{ maxOrdersCount() }}</span>
  </p>

  <div class="flex flex-col gap-[10px] w-[400px] mt-auto">
    <button
      type="button"
      class="h-[58px] w-full flex items-center justify-center border border-solid border-gris-3 rounded-[5px] text-[16px] font-medium fg-noir-2 cursor-pointer"
      (click)="backToSelectionClick.emit()"
    >
      {{ backToSelectionLabel() }}
    </button>
    <button
      type="button"
      class="h-[58px] w-full flex items-center justify-center bg-rose-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer"
      (click)="forcePassageClick.emit()"
    >
      {{ forcePassageLabel() }}
    </button>
  </div>
</app-modal-card>
